/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import CircularLoading from "../../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import { FirebaseContext } from "common";
import FlatList from "flatlist-react";
import { useNavigate } from "react-router-dom";
import Material_React_Table from "../../components/React_Material_Table/Material_React_Table";

import { Box } from "@mui/material";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Row,
  Col,
} from "reactstrap";

const NurseBookingHistory = (props) => {
  const { api } = useContext(FirebaseContext);
  const { fetchMedicalHistory } = api;
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  // const [role, setRole] = useState(null);
  // const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  // const [openConfirm, setOpenConfirm] = useState(false);
  // const [selectedBooking, setSelectedBooking] = useState("");
  const navigate = useNavigate();
  const bookinglistdata = useSelector((state) => state.bookinglistdata);
  //add isIndependent
  useEffect(() => {
    console.log("auth", auth.info.uid);
    console.log("booking", bookinglistdata.bookings);
    let arr = [];
    if (auth.info.profile.userType === "nurse") {
      if (bookinglistdata.bookings) {
        bookinglistdata.bookings.map((booking) => {
          if (booking?.nurse?.uid !== undefined) {
            if (
              booking.nurse.uid === auth.info.uid &&
              booking.status === "ACCEPTED"
            ) {
              arr.push(booking);
            }
          }

          setData(arr);
        });
      } else {
        setData([]);
      }
    }
  }, [bookinglistdata.bookings]);

  const columns = [
    {
      accessorKey: "patientImage",
      header: "Patient",
      Cell: ({ cell }) => (
        <img
          src={cell.getValue()}
          alt="Patient"
          style={{ width: 40, height: 40, borderRadius: "50%" }}
        />
      ),
    },
    {
      accessorKey: "patientName",
      header: "Patient Name",
    },
    {
      accessorKey: "serviceType",
      header: "Service Type",
    },
    {
      accessorKey: "eventDate",
      header: "Booking Date/Time",
    },
    {
      accessorKey: "status",
      header: "Status",
    },
    {
      id: "actions",
      header: "Actions",
      Cell: ({ row }) => (
        <Button
          variant="contained"
          size="small"
          onClick={() => {
            navigate("/nursebookings", { state: { Booking: row.original } });
            dispatch(fetchMedicalHistory(row.original.patient));
          }}
        >
          View Booking
        </Button>
      ),
    },
  ];



  return data.loading ? (
    <CircularLoading />
  ) : (
 <Box>
    {/* <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
      {commonAlert.msg}
    </AlertDialog> */}
    <Material_React_Table
      data={data}
      columns={columns}
      userInitialState={{
        columnVisibility: { id: false }, // This hides the "id" column initially
      }}
      // onRowAdd={onRowAdd}
      // onRowUpdate={onRowUpdate}
      // onRowDelete={onRowDelete}
    />
  </Box>
  );

};
export default NurseBookingHistory;
